import * as _ from 'lodash';
import {
  GET_DELIVERY_USER_DATA_SUCCEEDED,
  GET_DELIVERYS_REQUESTED,
  GET_DELIVERYS_SUCCEEDED
} from './edit.actions';


export const edit = (state = { fetched: false, data: {}, address: null, customer: null }, action) => {
  switch (action.type) {
    case GET_DELIVERYS_SUCCEEDED:
      return _.assign({}, state, {
        fetched: true,
        data: action.data
      });
    case GET_DELIVERYS_REQUESTED:
      return _.assign({}, state, {
        fetched: false
      });
    case GET_DELIVERY_USER_DATA_SUCCEEDED:
      return _.assign({}, state, {
        address: action.data ? action.data.getDefaultAddress() : null,
        customer: action.data ? action.data.getDefaultCustomer() : null,
      });
    default:
      return state;
  }
};
